export const sumOfOwnerBill = (calculatorUtilities) => {
  let newBTVBill = 0;
  let newATPBill = 0;
  let newOwnerBill = 0;

  for (let val in calculatorUtilities) {
    newBTVBill += calculatorUtilities[val].BTV;
    newATPBill += calculatorUtilities[val].ATP;
  }
  newOwnerBill = (newBTVBill - newATPBill).toFixed(2);

  return newOwnerBill;
};
